//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.166626 8.51659V5.73286H13.8854V8.51659H0.166626ZM5.39673 13.5487V0.566895H8.6279V13.5487H5.39673Z"
      :style="{ fill: store.state.Style.themeColor }"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
